<template>
  <div class="all-courses-page">
    <Navbar />
    <PageBanner :title="pageTitle" />
    <Breadcrumb :items="breadcrumbItems" class="intro-breadcrumb" />

    <div class="content">
      <div class="intro-section">
        <p class="intro-text">
          衷心感謝所有在 FHIR 領域辛勤付出的專家們，正因為有您們的努力，臺灣的智慧醫療才能持續向前邁進，實現更高效的醫療服務與健康管理。
        </p>
      </div>

      <div class="expert-list">
        <div class="expert-item" v-for="(expert, index) in experts" :key="index">
          {{ expert }}
        </div>
      </div>
    </div>

  </div>
  <FooterSection />
</template>

<script setup>
import Navbar from "@/components/Navbar.vue";
import FooterSection from "@/components/FooterSection.vue";
import PageBanner from "@/components/PageBanner.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { contentAPI } from "@/services/api";

const { t, locale } = useI18n();
const record = ref(null);

const isEnglish = computed(() => String(locale.value).toLowerCase().includes("en"));

const pageTitle = computed(() => t("navbar.expertDirectory"));

const breadcrumbItems = computed(() => [
  { label: t("common.home"), path: "/" },
  { label: t("navbar.expertDirectory") },
]);

const experts = computed(() => {
  const bio = record.value
    ? isEnglish.value
      ? record.value.bio_en || record.value.bio
      : record.value.bio
    : "";
  if (!bio) return [];
  return String(bio)
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
});

onMounted(async () => {
  try {
    const res = await contentAPI.expertDirectory();
    if (Array.isArray(res.data) && res.data.length > 0) {
      record.value = res.data[0];
    }
  } catch {}
});

</script>


<style scoped lang="scss">
.all-courses-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 80px auto;
  padding: 40px 20px;
  box-sizing: border-box;
  flex: 1;
}

.intro-section {
  margin-bottom: 60px;
}

.intro-text {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin: 0;
}

.expert-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 24px;
  column-gap: 40px;
}

.expert-item {
  font-size: 16px;
  color: #333;
}

/* ── RWD ── */
@media (max-width: 768px) {
  .content {
    padding: 24px 16px;
  }
  .intro-section {
    margin-bottom: 40px;
  }
  .expert-list {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
}
</style>
